import type { ComponentsProps } from '@material-ui/core/styles/props'

export const props: ComponentsProps = {
  MuiSwitch: {
    color: 'default',
  },
  MuiTextField: {
    variant: 'outlined',
  },
}
